import React from 'react';
import { Card, Row, Col, Form, Button } from 'antd';
import { TeamOutlined, AppstoreOutlined, PlusOutlined } from '@ant-design/icons';

import TeamHeader from './components/TeamHeader';
import CarSelect from './components/CarSelect';
import CompactStaffCard from './components/CompactStaffCard';
import EmptyState from './components/EmptyState';
import ObjectCard from './components/ObjectCard';
import TeamComment from './components/TeamComment';

export const TeamCard = ({
                             team,
                             index,
                             allcars,
                             cars,
                             removeTeam,
                             updateTeamField,
                             removeStaffFromTeam,
                             removeObjectFromTeam,
                             updateObjectComment,
                             openAddStaffModal,
                             openAddObjectsModal
                         }) => {
    const handleRoleChange = (teamIndex, personId, role, isChecked) => {
        if (role === 'driver') {
            updateTeamField(teamIndex, 'driver', isChecked ? personId : null);
        } else if (role === 'lead') {
            updateTeamField(teamIndex, 'lead', isChecked ? personId : null);
        }
    };

    return (
        <Card
            style={{ marginBottom: 16, borderRadius: 8 }}
            title={
                <TeamHeader
                    index={index}
                    onRemove={() => removeTeam(index)}
                />
            }
        >
            {/* Выбор автомобиля на всю ширину */}
            <Row gutter={16} style={{ marginBottom: 24 }}>
                <Col xs={24}>
                    <CarSelect
                        value={team.carId}
                        cars={cars}
                        allcars={allcars}
                        onChange={(value) => updateTeamField(index, 'carId', value)}
                    />
                </Col>
            </Row>

            {/* Колонки с сотрудниками, объектами и комментарием */}
            <Row gutter={16}>
                <Col xs={24} md={8}>
                    <Form.Item label="Сотрудники команды">
                        <Card
                            size="small"
                            style={{
                                minHeight: 200,
                                border: '2px dashed #d9d9d9',
                                background: team.staff.length === 0 ? '#fafafa' : 'white',
                                borderRadius: 6
                            }}
                            bodyStyle={{ padding: team.staff.length === 0 ? 0 : '12px' }}
                        >
                            {team.staff.length === 0 ? (
                                <EmptyState
                                    icon={<TeamOutlined />}
                                    buttonText="Добавить сотрудников"
                                    onButtonClick={() => openAddStaffModal(index)}
                                />
                            ) : (
                                <>
                                    {team.staff.map(person => (
                                        <CompactStaffCard
                                            key={person.id}
                                            person={person}
                                            teamIndex={index}
                                            isDriver={team.driver === person.id}
                                            isLead={team.lead === person.id}
                                            onRoleChange={handleRoleChange}
                                            onRemove={() => removeStaffFromTeam(index, person.id)}
                                        />
                                    ))}
                                    <div style={{ textAlign: 'center', marginTop: 8 }}>
                                        <Button
                                            type="dashed"
                                            icon={<PlusOutlined />}
                                            onClick={() => openAddStaffModal(index)}
                                            style={{ width: '100%' }}
                                        >
                                            Добавить сотрудников
                                        </Button>
                                    </div>
                                </>
                            )}
                        </Card>
                    </Form.Item>
                </Col>

                <Col xs={24} md={8}>
                    <Form.Item label="Объекты команды">
                        <Card
                            size="small"
                            style={{
                                minHeight: 200,
                                border: '2px dashed #d9d9d9',
                                background: team.objects.length === 0 ? '#fafafa' : 'white',
                                borderRadius: 6
                            }}
                            bodyStyle={{ padding: team.objects.length === 0 ? 0 : '12px' }}
                        >
                            {team.objects.length === 0 ? (
                                <EmptyState
                                    icon={<AppstoreOutlined />}
                                    buttonText="Добавить объекты"
                                    onButtonClick={() => openAddObjectsModal(index)}
                                />
                            ) : (
                                <>
                                    {team.objects.map(obj => (
                                        <ObjectCard
                                            key={obj.id}
                                            obj={obj}
                                            teamIndex={index}
                                            onCommentChange={updateObjectComment}
                                            onRemove={removeObjectFromTeam}
                                        />
                                    ))}
                                    <div style={{ textAlign: 'center', marginTop: 8 }}>
                                        <Button
                                            type="dashed"
                                            icon={<PlusOutlined />}
                                            onClick={() => openAddObjectsModal(index)}
                                            style={{ width: '100%' }}
                                        >
                                            Добавить объекты
                                        </Button>
                                    </div>
                                </>
                            )}
                        </Card>
                    </Form.Item>
                </Col>

                <Col xs={24} md={8}>
                    <TeamComment
                        value={team.teamcomment}
                        onChange={(e) => updateTeamField(index, 'teamcomment', e.target.value)}
                    />
                </Col>
            </Row>
        </Card>
    );
};